import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { heartOnePageMeta, heartOneSchema } from 'components/common/schema'
import Template from 'components/cases/heart-one'

const HeartOne: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...heartOnePageMeta} />
      <JsonLd data={heartOneSchema} />
      <Template />
    </>
  )
}

export default HeartOne
